import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { handleFieldChange } from '../../../helpers/ReactUtils';
import { showError } from '../../../common/A1Alert/A1Alert';

export class RequestPasswordReset extends Component {
    constructor(props) {
        super(props);

        this.state = {
            emailPwReset: '',
        };
    }


    componentDidMount() {
        // reset the fields here? (Or better leave the message so that the user do not request endless pw resets?)
    }

    onSubmit = (e) => {
        e.preventDefault();

        const { emailPwReset } = this.state;

        if (isEmpty(emailPwReset)) {
            showError('Insira seu e-mail de cadastro para criar uma nova senha');
            // Insere o email do seu cadastro para criar uma nova senha!

            return;
        }

        this.props.requestPasswordReset(emailPwReset);
    };

    render() {
        const { emailPwReset } = this.state;
        const { passwordResetRequested, submitting } = this.props;

        return (
            <section className="sectionRequestPasswordReset">
                <h2>Esqueceu sua senha?</h2>
                <div className="containerRequestPasswordReset">
                    {
                        passwordResetRequested ?
                            <div className="successRequestPasswordReset">Uma nova mensagem foi enviada para a sua caixa de e-mail, contendo as instruções para resetar sua senha.</div>
                            :
                            <form onSubmit={this.onSubmit}>
                                {!passwordResetRequested &&
                                <div>
                                    <h3>Insira o seu e-mail e nós enviaremos instruções para criar uma nova senha.</h3>
                                    <div className="emailRequestPasswordReset">
                                        <label>E-mail</label>
                                        <input type="text" placeholder="" id="emailPwReset" value={emailPwReset} onChange={handleFieldChange(this)} />
                                    </div>
                                    <div className="submitRequestPasswordReset">
                                        <button type="submit" disabled={!!submitting} className="cta">
                                            {submitting === 'requestPasswordReset' ? 'Enviando...' : 'Enviar'}
                                        </button>
                                    </div>
                                </div>}
                            </form>
                    }
                </div>
            </section>
        );
    }
}

RequestPasswordReset.propTypes = exact({
    passwordResetRequested: PropTypes.bool.isRequired,
    requestPasswordReset: PropTypes.func.isRequired,
    submitting: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]).isRequired,
});

export default RequestPasswordReset;
